<!-- 创建时间2022/10/25 14:02:00 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述： -->
<template>
    <!-- 权限组 -->
  <div v-if="config.prefix && config.auth && config.auth.length" class="yxtbiz-kng-audit-content__node">
    <span class="mr12 mb12">{{config.prefix}}</span>
    <span class="mr12 mb12 yxtbiz-kng-audit-content__node-item" v-for="item in config.auth" :key="item.userGroupId">
      <yxt-svg class="mr4" width="16px" height="16px" :icon-class="getSvgName(item)"/>
      <yxtbiz-dept-name v-if="item.groupType === GROUP_AUTH_TYPE.DEPT" :name="item.userGroupName"/>
      <yxtbiz-user-name v-else :name="item.userGroupName"/>
    </span>
    <yxt-tag v-if="config.isChange" class="mr12 mb12" type="warning" size="mini">{{$t('pc_biz_kng_lbl_hadchanged'/** 已更改 */)}}</yxt-tag>
  </div>
    <!-- 人名 -->
  <div v-else-if="config.userName">
    <yxtbiz-user-name v-if="config.userName" :name="config.userName" />
    <span>{{config.suffix}}</span>
    <yxt-tag v-if="config.isChange" class="ml12" type="warning" size="mini">{{$t('pc_biz_kng_lbl_hadchanged'/** 已更改 */)}}</yxt-tag>
  </div>
  <!-- 附件&标签 -->
  <div v-else-if="isContentArray" class="yxtbiz-kng-audit-content__node">
    <template v-for="(item,index) in config.content" >
      <yxt-tooltip :key="index" open-filter :content="item">
        <span class="mr12 mb12 ellipsis-1" >{{item}}</span>
      </yxt-tooltip>
    </template>
    <span class="mr12 mb12" v-if="config.content.length === 0">--</span>
    <yxt-tag v-if="config.isChange" class="mr12 mb12" type="warning" size="mini">{{$t('pc_biz_kng_lbl_hadchanged'/** 已更改 */)}}</yxt-tag>
  </div>

  <!-- 其他tooltip -->
  <div v-else-if="!!config.textLine" class="yxtbiz-kng-audit-content__ellipsis">
    <yxt-tooltip open-filter >
      <div class="yxtbiz-kng-audit-content__node-content" slot="content" v-html="config.content || '--'"></div>
      <div class="yxtbiz-kng-audit-content__node-content" :class="customClass" v-html="config.content || '--'" @click="preview"></div>
    </yxt-tooltip>
    <yxt-tag v-if="config.isChange" class="ml12 v-top" type="warning" size="mini">{{$t('pc_biz_kng_lbl_hadchanged'/** 已更改 */)}}</yxt-tag>
  </div>
  
  <!-- 其他 -->
  <div v-else>
      <span class="yxtbiz-kng-audit-content__node-content" v-html="config.content || '--'"></span>
      <yxt-tag v-if="config.isChange" class="ml12" type="warning" size="mini">{{$t('pc_biz_kng_lbl_hadchanged'/** 已更改 */)}}</yxt-tag>
  </div>
</template>

<script>
import { GROUP_AUTH_TYPE } from '../enum';
export default {
  name: 'TextNode',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      GROUP_AUTH_TYPE
    };
  },
  computed: {
    customClass() {
      let className = '';
      if (this.config.textLine > 0) className += `ellipsis-${this.config.textLine}`;
      if (this.config.preview) className += ' hover=primary-6 color-primary-6 cursor-pointer';
      return className;
    },
    isContentArray() {
      return Array.isArray(this.config.content);
    },
    content() {
      const item = this.config.content;
      if (Array.isArray(item)) return item.join('、');
      return item;
    }
  },
  methods: {
    getSvgName(item) {
      switch (item.groupType) {
        case GROUP_AUTH_TYPE.DEPT:
          return 'common_dept';
        case GROUP_AUTH_TYPE.POSITION:
          return 'position';
        case GROUP_AUTH_TYPE.USER_GROUP:
          return 'usergroup';
        case GROUP_AUTH_TYPE.ROLE:
          return 'role';
        case GROUP_AUTH_TYPE.USER:
          return 'person-center';
        default:
          return 'person-center';
      }
    },
    preview() {
      this.config.preview && this.$emit('preview');
    }
  }
};
</script>